import { Box, Button, Card, FormControl, MenuItem, styled, TextField, useTheme, CircularProgress } from "@mui/material";

const BoxWrapper = styled(Box)(({ theme }) => ({
  "& .DateAndCurrencyWrapper": {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    "@media screen and (max-width:600px)": {
      flexDirection: "column",
    },
    "& .MuiFormControl-root": {
      "& label": {
        marginBottom: "0",
        top: "50%",
        transform: "translate(14px, -50%)",
        "&.MuiInputLabel-shrink": {
          top: "0",
          transform: "translate(14px, -9px) scale(0.75)",
        },
      },
    },
    "& button": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      minWidth: "auto",
      padding: "10px 28px 10px",
      "@media screen and (max-width:600px)": {
        width: "100%",
      },
      "& .MuiCircularProgress-root": {
        color: "#fff",
      },
    },
    "& .addKeyword": {
      width: "211.78px",
      "@media screen and (max-width:600px)": {
        width: "100%",
      },
    },
  },
}));
function ProjectSelectBox({ scrapyData, handleProjectChange, selectedProjectId, handleBlogGenerator, handleKeywordSave, disabled, isKeywordLoading }) {
  const theme = useTheme();
  return (
    <BoxWrapper>
      <Card
        sx={{
          padding: "16px 16px 16px 16px",
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: "none !important",
        }}
      >
        <Box className="DateAndCurrencyWrapper">
          <FormControl sx={{ flex: "1", width: { xs: "100%", sm: "auto" } }}>
            <TextField select label="Select Project" disabled={disabled} variant="outlined" value={selectedProjectId} onChange={handleProjectChange}>
              {scrapyData.map(project => (
                <MenuItem key={project.id} value={project.id}>
                  {project.projectName}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
          <Button onClick={handleBlogGenerator} disabled={disabled}>
            Generate blog
          </Button>
          <Button className="addKeyword" onClick={handleKeywordSave} disabled={isKeywordLoading}>
            {isKeywordLoading ? <CircularProgress size={24} /> : "Add keyword to project"}
          </Button>
        </Box>
      </Card>
    </BoxWrapper>
  );
}

export default ProjectSelectBox;
